import { MultiTenantOrganizationDetails } from '@ms/yammer-graphql';

import { NormalizedMultiTenantOrganizationDetails } from './types';

type NormalizeMultiTenantOrganizationDetails = (response: {
  readonly data: MultiTenantOrganizationDetails;
}) => NormalizedMultiTenantOrganizationDetails;

export const normalizeMultiTenantOrganizationDetails: NormalizeMultiTenantOrganizationDetails = (response) => ({
  multiTenantHubNetwork: response.data.viewer.multiTenantHubNetwork,
});
